import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import * as _ from 'lodash';
import * as moment from 'moment';

import { DownloadService } from './../../download/download.service';

@Component({
  selector: 'app-dashboard-download-stat',
  templateUrl: './dashboard-download-stat.component.html',
  styleUrls: ['./dashboard-download-stat.component.scss']
})
export class DashboardDownloadStatComponent implements OnInit {
  barChartOptions: ChartOptions = {
    responsive: true
  };
  barChartLabels = [
    'มกราคม',
    'กุมภาพันธ์',
    'มีนาคม',
    'เมษายน',
    'พฤษภาคม',
    'มิถุนายน',
    'กรกฎาคม',
    'สิงหาคม',
    'กันยายน',
    'ตุลาคม',
    'พฤศจิกายน',
    'ธันวาคม'
  ];
  barChartType: ChartType = 'bar';
  barChartPlugins = [];

  barChartData: ChartDataSets[] = [
    { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'ข้อมูลคำร้องขอดูเอกสาร' }
  ];

  constructor(private downloadService: DownloadService) {}

  ngOnInit() {
    this.getDocumentDownloadList();
  }

  getDocumentDownloadList() {
    const params = new HttpParams().set('none_pagination', 'True');
    this.downloadService.getDocumentRequestList(params).subscribe(
      res => {
        res.map(o => (o['month'] = moment(o.created_at).format('M')));
        const data = _.groupBy(res, 'month');
        this.barChartData = [
          data['1'] ? data['1'].length : 0,
          data['2'] ? data['2'].length : 0,
          data['3'] ? data['3'].length : 0,
          data['4'] ? data['4'].length : 0,
          data['5'] ? data['5'].length : 0,
          data['6'] ? data['6'].length : 0,
          data['7'] ? data['7'].length : 0,
          data['8'] ? data['8'].length : 0,
          data['9'] ? data['9'].length : 0,
          data['10'] ? data['10'].length : 0,
          data['11'] ? data['11'].length : 0,
          data['12'] ? data['12'].length : 0
        ];
      },
      error => console.log('error', error)
    );
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-download-stat/dashboard-download-stat.component.ts